import React, { useState } from 'react';
import styles from './RegisterSaleModal.module.css'; // Reutiliza os estilos do modal principal

const ProductSelector = ({ categoryProducts, label, onAddProduct }) => {
  const [selected, setSelected] = useState('');
  const [quantity, setQuantity] = useState(1);

  const handleAdd = () => {
    if (selected) {
      onAddProduct(selected, quantity);
      setSelected(''); // Reseta o seletor após adicionar
      setQuantity(1); // Reseta a quantidade
    }
  };

  const incrementQuantity = () => setQuantity(prev => prev + 1);
  const decrementQuantity = () => setQuantity(prev => Math.max(1, prev - 1)); // Impede que a quantidade seja menor que 1

  return (
    <div className={styles.addItemForm}>
      <select value={selected} onChange={(e) => setSelected(e.target.value)}>
        <option value="">{label}</option>
        {categoryProducts.map(p => <option key={p.name} value={p.name}>{p.name}</option>)}
      </select>
      {/* Novo controle de quantidade com botões +/- */}
      <div className={styles.quantityControl}>
        <button type="button" onClick={decrementQuantity} className={styles.quantityBtn}>-</button>
        <span className={styles.quantityDisplay}>{quantity}</span>
        <button type="button" onClick={incrementQuantity} className={styles.quantityBtn}>+</button>
      </div>
      <button type="button" onClick={handleAdd} disabled={!selected}>Adicionar</button>
    </div>
  );
};

export default ProductSelector;